module.exports = __webpack_public_path__ + "static/media/cough_function_2.b79cc3b6.png";